import type { QuillOptions } from "react-quill";

// Minimal toolbar (bold, italic only)
export const minimalModules: QuillOptions["modules"] = {
  toolbar: [["bold", "italic"]],
};

// Standard toolbar (default)
export const standardModules: QuillOptions["modules"] = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["clean"],
  ],
};

// Full toolbar
export const fullModules: QuillOptions["modules"] = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    ["link"],
    ["clean"],
  ],
};

// Corresponding formats
export const minimalFormats = ["bold", "italic"];

export const standardFormats = [
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
];

export const fullFormats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "indent",
  "link",
];